import { CONVERSATION_LIST_QUERY_TAG } from '@zg-rentals/satellite-inbox/hooks/useInfiniteConversationList';
import { MESSAGES_QUERY_TAG } from '@zg-rentals/satellite-inbox/hooks/useMessages';
import type { QueryClient } from '@zg-rentals/react-query5';
import {
  hpToursKeys,
  inquiryKeys,
  listingDetailKeys,
  recentSearchKeys,
  renterProfileKeys,
  savedSearchKeys,
  searchKeys,
  userListingKeys,
} from './queryKeys';

const SATELLITE_QUERY_TAGS: Array<string> = [CONVERSATION_LIST_QUERY_TAG, MESSAGES_QUERY_TAG];

/**
 * Evict user-scoped caches on logout. These queries are keyed without a user
 * id and mostly disabled while logged out, so invalidation alone would keep
 * serving the previous user's data.
 */
export function removeUserScopedQueries(queryClient: QueryClient) {
  queryClient.removeQueries({ queryKey: userListingKeys.all });
  queryClient.removeQueries({ queryKey: savedSearchKeys.all });
  queryClient.removeQueries({ queryKey: recentSearchKeys.all });
  queryClient.removeQueries({ queryKey: renterProfileKeys.all });
  queryClient.removeQueries({ queryKey: inquiryKeys.all });
  queryClient.removeQueries({ queryKey: hpToursKeys.all });
  // Literal prefix instead of notificationKeys: importing useNotificationSettings here
  // would create an import cycle through useUserQuery.
  queryClient.removeQueries({ queryKey: ['notifications'] });
  queryClient.removeQueries({
    predicate: ({ meta }) => meta?.tags?.some((tag) => SATELLITE_QUERY_TAGS.includes(tag)) ?? false,
  });
  // Search/detail payloads bake in the session's userItemTypes (hearts,
  // marker colors); invalidate so mounted views refetch immediately — removal
  // would break placeholderData continuity.
  void queryClient.invalidateQueries({ queryKey: searchKeys.all });
  void queryClient.invalidateQueries({ queryKey: listingDetailKeys.all });
}
